import { Schema } from "prosemirror-model";
import { tableNodes } from "prosemirror-tables";
//import { isPositiveNumber } from "../commands/custom-commands";

function isPositiveNumber(string) {
  const numeric = Number(string);

  return Number.isFinite(numeric) && numeric > 0;
}

export const validParagraphClasses = [
  //{ value: "", label: "Párrafo sin sangría" },
  { value: "sangria", label: "Párrafo con sangría en primera línea" },
  //{ value: "margen-izq", label: "Párrafo con margen a la izquierda" },
  { value: "frances", label: "Párrafo francés" },
  { value: "paratexto", label: "Paratexto" },
  { value: "bando", label: "Bando" }
];
export const validParagraphValues = validParagraphClasses.map(type => type.value);
export const validFontColorClasses = [
  { value: "violeta", label: "Violeta" },
  { value: "lila", label: "Lila" },
  { value: "gris2", label: "Gris" },
  { value: "blanca", label: "Blanco" }
];
export const validFontColorValues = validFontColorClasses.map(colorClass => colorClass.value);
export const validBackgroundColorClasses = [
  { value: "violeta", label: "Violeta" },
  { value: "lila", label: "Lila" },
  { value:  "gris2", label: "Gris" },
  { value: "negro", label: "Negro" }
];
export const validBackgroundColorValues = validBackgroundColorClasses.map(colorClass => colorClass.value);
export const validFontSizeClasses = [
  { value: "30px", label: "Título principal (30px)" },
  { value: "22px", label: "Subtítulos (22px)" },
  { value: "15px", label: "Paratextos (15px)" },
  { value: "14px", label: "Fuentes (14px)" },
  { value: "12px", label: "Notas (12px)" }
];
export const validFontSizeValues = validFontSizeClasses.map(sizeClass => sizeClass.value);
export const validMarginBottomClasses = [
  { value: "triple", label: "Triple línea" },
  { value: "doble", label: "Doble línea" },
  { value: "sencillo", label: "Una línea" },
  { value: "mitad", label: "Media línea" },
  { value: "nulo", label: "Sin margen" }
];
export const validMarginBottomValues = validMarginBottomClasses.map(mbClass => mbClass.value);
export const validLinkTypes = [
  { value: "autor", label: "Nota de autor" },
  { value: "editor", label: "Nota de editor" }
];
export const ValidLinkValues = validLinkTypes.map(type => type.value);
export const validHeadingLevels = [
  { value: 1, label: "Título" },
  { value: 2, label: "Subtítulo" },
  { value: 3, label: "Encabezado de sección" },
  { value: 4, label: "Encabezado de subsección" },
  { value: 5, label: "Encabezado de anotación" },
  { value: 6, label: "Encabezado de detalle" }
];
export const validHeadingValues = validHeadingLevels.map(level => level.value.toString());
export const validOrderedListTypes = [
  { value: "decimal", label: "Decimales" },
  { value: "lower-roman", label: "Numeración romana (minúsculas)" },
  { value: "upper-roman", label: "Numeración romana (mayúsculas)" },
  { value: "lower-alpha", label: "Letras (minúsculas)" },
  { value: "upper-alpha", label: "Letras (mayúsculas)" }
];
export const validOrderedListValues = validOrderedListTypes.map(type => type.value);
export const validUnorderedListTypes = [
  { value: "disc", label: "Viñeta" },
  { value: "circle", label: "Circunferencia" },
  { value: "square", label: "Recuadros" }
];
export const validUnorderedListValues = validUnorderedListTypes.map(type => type.value);
export const validAlignTypes = [
  { value: "centrado", label: "Centrado" },
  { value: "derecha", label: "A la derecha" },
  { value: "justificado", label: "Justificado" }
];
export const validAlignValues = validAlignTypes.map(type => type.value);
export const validPdfOrientations = [
  { value: "horizontal", label: "Horizontal" },
  { value: "vertical", label: "Vertical" }
]
export const validPdfOrientationValues = validPdfOrientations.map(type => type.value);
export const validNotesListTypes = [
  { value: "autor", label: "Notas de autor" },
  { value: "editor", label: "Notas de editor" }
];
export const validNotesListValues = validNotesListTypes.map(type => type.value);
export const validHorizontalRuleTypes = [
  { value: "", label: "Normal" },
  { value: "hr-decorado", label: "Con decoración" }
];
export const validHorizontalRuleValues = validHorizontalRuleTypes.map(type => type.value);
export const validSpecialChars = [
  { value: "\u201C", label: "Comilla doble izq. (\u201C)" },
  { value: "\u201D", label: "Comilla doble der. (\u201D)" },
  { value: "\u2018", label: "Comilla sencilla izq. (\u2018)" },
  { value: "\u2019", label: "Comilla sencilla der. (\u2019)" },
  { value: "\u00AB", label: "Comilla francesa izq. (\u00AB)" },
  { value: "\u00BB", label: "Comilla francesa der. (\u00BB)" },
  { value: "\u2039", label: "Comilla angular simple izq. (\u2039)" },
  { value: "\u203A", label: "Comilla angular simple der. (\u203A)" },
  { value: "\u2026", label: "Tres puntos (\u2026)" },
  { value: "\u2014", label: "Guión largo (\u2014)" },
  { value: "\u2042", label: "Asterismo (\u2042)" },
  { value: "\u25C8", label: "Diamante con relleno (\u25C8)" },
  { value: "\u0009", label: "Tabulación" }
];
export const validSepcialCharValues = validSpecialChars.map(type => type.value);

const tableNodesSchema = tableNodes({
  tableGroup: "block",
  cellContent: "(paragraph | heading | blockquote | orderedList | unorderedList | horizontalRule | figure | figureGraphic | embed)+"
});
export const validEditorTypes = ["full", "editor", "obra", "basic"];

tableNodesSchema.table = {
  ...tableNodesSchema.table,
  toDOM(node) {
    return ["table", { class: "tabla" }, 0];
  }
};

export const customSchema = new Schema({
  nodes: {
    doc: {
      content: "block+"
    },
    heading: {
      attrs: {
        level: {},
        id: { default: null },
        align: { default: null },
        color: { default: null },
        bgColor: { default: null },
        size: { default: null },
        marginBottom: { default: null },
        marginLeft: { default: null }
      },
      content: "inline*",
      group: "block",
      toDOM(node) {
        let { level, color, bgColor, size, align, id, type, marginBottom, marginLeft } = node.attrs,
          isValidId = true,
          attrs;
        /*const classes = [align, color, bgColor, size, marginBottom]
          .filter(className => className !== null && className.trim() !== "").join(" ");*/

        if(id === null || !/^[a-zA-Z][a-zA-Z0-9\-_:.]*$/.test(id)) {
          isValidId = false;
        }

        if(!validFontColorValues.includes(color)) {
          color = null;
        }

        if(!validBackgroundColorValues.includes(bgColor)) {
          bgColor = null;
        }

        if(!validFontSizeValues.includes(size)) {
          size = null;
        }

        if(!validAlignValues.includes(align)) {
          align = null;
        }

        if(!validMarginBottomValues.includes(marginBottom)) {
          marginBottom = null;
        }

        if(!isPositiveNumber(marginLeft)) {
          marginLeft = null;
        }

        attrs = {
          //class: classes,
          id: (isValidId ? id : null),
          "data-color": color,
          "data-bg": bgColor,
          "data-size": size,
          "data-align": align,
          //"data-level": level,
          "data-mb": marginBottom,
          "data-ml": marginLeft,
          "style": (!!marginLeft ? `--pm-ml:${marginLeft}ch` : null)
        };
        attrs = Object.fromEntries(Object.entries(attrs).filter(([key, value]) => { return value !== null && value !== ""}));
        switch(level) {
          case 1:
            return ["h1", attrs, 0];
          case 2:
            return ["h2", attrs, 0];
          case 3:
            return ["h3", attrs, 0];
          case 4:
            return ["h4", attrs, 0];
          case 5:
            return ["h5", attrs, 0];
          case 6:
            return ["h6", attrs, 0];
          default:
            return ["h1", attrs, 0];
        }
      },
      parseDOM: [
        {
          tag: "h1, h2, h3, h4, h5, h6",
          getAttrs(node) {
            const level = parseInt(node.nodeName.charAt(1), 10);
            let id = node.id,
              color = node.getAttribute("data-color"),
              bgColor = node.getAttribute("data-bg-color"),
              size = node.getAttribute("data-size"),
              align = node.getAttribute("data-align"),
              type = node.getAttribute("data-type"),
              marginBottom = node.getAttribute("data-mb");
              marginLeft = node.getAttribute("data-ml");

            if(id === null || !/^[a-zA-Z][a-zA-Z0-9\-_:.]*$/.test(id)) {
              isValidId = false;
            }

            if(!validFontColorValues.includes(color)) {
              color = null;
            }

            if(!validBackgroundColorValues.includes(bgColor)) {
              bgColor = null;
            }

            if(!validFontSizeValues.includes(size)) {
              size = null;
            }

            if(!validAlignValues.includes(align)) {
              align = null;
            }

            if(!validMarginBottomValues.includes(marginBottom)) {
              marginBottom = null;
            }

            if(!isPositiveNumber(marginLeft)) {
              marginLeft = null;
            }

            return { level, id, color, bgColor, size, align, marginBottom, marginLeft };
          }
        }
      ]
    },
    paragraph: {
      attrs: {
        type: { default: null },
        id: { default: null },
        align: { default: null },
        color: { default: null },
        bgColor: { default: null },
        size: { default: null },
        marginBottom: { default: null },
        marginLeft: { default: null }
      },
      content: "inline*",
      group: "block",
      toDOM(node) {
        let { color, bgColor, size, align, id, type, marginBottom, marginLeft } = node.attrs,
          isValidId = true,
          attrs;
        /*const classes = [type, align, color, bgColor, size, marginBottom]
          .filter(className => className !== null && className.trim() !== "").join(" ");*/

        if(id === null || !/^[a-zA-Z][a-zA-Z0-9\-_:.]*$/.test(id)) {
          isValidId = false;
        }

        if(!validFontColorValues.includes(color)) {
          color = null;
        }

        if(!validBackgroundColorValues.includes(bgColor)) {
          bgColor = null;
        }

        if(!validFontSizeValues.includes(size)) {
          size = null;
        }

        if(!validAlignValues.includes(align)) {
          align = null;
        }

        if(!type || !validParagraphValues.includes(type)) {
          type = null;
        }

        if(!validMarginBottomValues.includes(marginBottom)) {
          marginBottom = null;
        }

        if(!isPositiveNumber(marginLeft)) {
          marginLeft = null;
        }

        attrs = {
          //class: classes,
          id: (isValidId ? id : null),
          "data-color": color,
          "data-bg": bgColor,
          "data-size": size,
          "data-align": align,
          "data-type": type,
          "data-mb": marginBottom,
          "data-ml": marginLeft,
          "style": (!!marginLeft ? `--pm-ml:${marginLeft}ch` : null)
        };
        attrs = Object.fromEntries(Object.entries(attrs).filter(([key, value]) => { return value !== null && value !== ""}));

        return ["p", attrs, 0];
      },
      parseDOM: [
        {
          tag: "p",
          getAttrs(node) {
            let id = node.id,
              color = node.getAttribute("data-color"),
              bgColor = node.getAttribute("data-bg"),
              size = node.getAttribute("data-size"),
              align = node.getAttribute("data-align"),
              type = node.getAttribute("data-type"),
              marginBottom = node.getAttribute("data-mb");
              marginLeft = node.getAttribute("data-ml");

            if(id === null || !/^[a-zA-Z][a-zA-Z0-9\-_:.]*$/.test(id)) {
              isValidId = false;
            }

            if(!color || !validFontColorValues.includes(color)) {
              color = null;
            }

            if(!validBackgroundColorValues.includes(bgColor)) {
              bgColor = null;
            }

            if(!validFontSizeValues.includes(size)) {
              size = null;
            }

            if(!validAlignValues.includes(align)) {
              align = null;
            }

            if(!validParagraphValues.includes(type)) {
              type = null;
            }

            if(!validMarginBottomValues.includes(marginBottom)) {
              marginBottom = null;
            }

            if(!isPositiveNumber(marginLeft)) {
              marginLeft = null;
            }

            return { id, color, bgColor, size, align, type, marginBottom, marginLeft };
          }
        }
      ]
    },
    /*paragraphSummary: {
      content: "inline*",
      toDOM() {
        return ["p", { class: "acordeon-titulo-parrafo" }, 0];
      },
      parseDOM: [
        { tag: "p.acordeon-titulo-parrafo" }
      ],
      marks: "bold italics underline smallCaps strikeThrough subscript superscript inlineCode"
    },*/
    horizontalRule: {
      attrs: {
        cssClass: { default: null }
      },
      group: "block",
      content: "",
      atom: true,
      selectable: true,
      draggable: true,
      defining: true,
      toDOM(node) {
        if(node.attrs.cssClass === null) {
          return ["hr", {}];
        }

        return ["hr", { class: node.attrs.cssClass }];
      },
      parseDOM: [
        {
          tag: "hr",
          getAttrs(node) {
            const { className } = node;
            if(className === "" || className === null) {
              return {}
            }

            return { cssClass: className };
          }
        }
      ],
      marks: ""
    },
    notesList: {
      attrs: {
        type: { default: "autor" }
      },
      content: "listItem+",
      group: "block",
      toDOM(node) {
        let { type } = node.attrs;

        if(!validNotesListValues.includes(type)) {
          type = validNotesListValues[0];
        }

        return ["ol", { class: "lista-notas", "data-section": type }, 0];
      },
      parseDOM: [
        {
          tag: "ol[data-section]",
          getAttrs: (node) => {
            let type = node.getAttribute("data-section");

            if(!validNotesListValues.includes(type)) {
              type = validNotesListValues[0];
            }

            return { type };
          }
        }
      ]
    },
    orderedList: {
      attrs: {
        type: { default: "decimal" }
      },
      content: "listItem+",
      group: "block",
      toDOM(node) {
        let { type } = node.attrs;

        if(!validOrderedListValues.includes(type)) {
          type = "decimal";
        }

        return ["ol", { class: "lista", "data-type": type }, 0];
      },
      parseDOM: [
        {
          tag: "ol:not([data-section])",
          getAttrs: (node) => {
            let type = node.getAttribute("data-type");
            if(!validOrderedListValues.includes(type)) {
              type = "decimal";
            }

            return { type };
          }
        }
      ]
    },
    unorderedList: {
      attrs: {
        type: { default: "disc" }
      },
      content: "listItem+",
      group: "block",
      toDOM(node) {
        let { type } = node.attrs;

        if(!validUnorderedListValues.includes(type)) {
          type = "disc";
        }

        return ["ul", { class: "lista", "data-type": type }, 0];
      },
      parseDOM: [
        {
          tag: "ul",
          getAttrs: (node) => {
            let type = node.getAttribute("data-type");
            if(!validUnorderedListValues.includes(type)) {
              type = "disc";
            }

            return { type };
          }
        }
      ]
    },
    listItem:{
      attrs: {
        id: { default: null }
      },
      content: "block+",
      toDOM(node) { return ["li", { id: node.attrs.id }, 0]; },
      parseDOM: [
        {
          tag: "li",
          getAttrs: (node) => {
            const id = node.closest("ol[data-section]") ? node.id : null;

            return { id };
          }
        }
      ],
      defining: true
    },
    hardBreak: {
      inline: true,
      group: "inline",
      selectable: false,
      toDOM() { return ["br"]; },
      parseDOM: [{ tag: "br" }]
    },
    blockquote: {
      content: "block+",
      group: "block",
      defining: true,
      toDOM() { return ["blockquote", { class: "cita" }, 0]; },
      parseDOM: [
        { tag: "blockquote, .cita" }
      ]
    },
    figureGraphic: {
      content: "image",
      group: "block",
      draggable: true,
      selectable: true,
      toDOM(node) {
        return ["figure", { class: "grafico" }, 0];
      },
      parseDOM: [
        { tag: "figure.grafico:not(:has(figcaption))" }
      ]
    },
    pdfContainer: {
      attrs: {
        src: { default: null },
        orientation: { default: "horizontal" }
      },
      group: "block",
      draggable: true,
      selectable: true,
      toDOM(node) {
        return ["iframe", { class: "contenedor-pdf", src: node.attrs.src, "data-orientation": node.attrs.orientation }];
      },
      parseDOM: [
        {
          tag: "iframe.contenedor-pdf[src]",
          getAttrs(node) {
            const src = node.getAttribute("src"),
              orientation = node.getAttribute("data-orientation") === "vertical" ? "vertical" : "horizontal";

            return { src, orientation };
          }
        }
      ]
    },
    figure: {
      content: "image figcaption",
      group: "block",
      draggable: true,
      selectable: true,
      toDOM(node) {
        return ["figure", { class: "grafico" }, 0];
      },
      parseDOM: [
        { tag: "figure.grafico:has(figcaption)" }
      ]
    },
    image: {
      attrs: {
        src: { default: null }
      },
      toDOM(node) {
        return ["img", { src: node.attrs.src, alt: "" }];
      },
      parseDOM: [
        {
          tag: "img[src]",
          getAttrs: (node) => {
            const src = node.getAttribute("src");

            return { src };
          }
        }
      ]
    },
    figcaption: {
      content: "inline*",
      toDOM(node) {
        return ["figcaption", { class: "anotacion" }, 0];
      },
      parseDOM: [
        { tag: "figcaption" }
      ],
      marks: "_"
    },
    embed: {
      attrs: {
        src: { default: null },
        metadata: { default: {} }
      },
      group: "block",
      selectable: true,
      draggable: true,
      atom: true,
      toDOM(node) {
        const { src } = node.attrs;

        return ["iframe", { src, class: "embed", ...node.attrs.metadata }]
      },
      parseDOM: [
        {
          tag: "iframe.embed[src]",
          getAttrs: (node) => {
            const src = node.getAttribute("src"),
              metadata = {},
              loading = node.getAttribute("loading"),
              type = node.getAttribute("data-type"),
              isList = node.getAttribute("data-list"),
              allow = node.getAttribute("allow");
            
            if(loading !== null) {
              metadata.loading = loading;
            }
            
            if(type !== null) {
              metadata["data-type"] = type;
            }
            
            if(isList !== null) {
              metadata["data-list"] = isList;
            }
            
            if(allow !== null) {
              metadata.allow = allow;
            }

            return { src, metadata };
          }
        }
      ]
    },
    ...tableNodesSchema,
    note: {
      group: "inline",
      inline: true,
      content: "inline*",
      atom: true,
      attrs: {
        href: { default: null },
        index: { default: null },
        type: {}
      },
      toDOM(node) {
        const { index, type, id } = node.attrs;

        return ["a", { class: "liga", id: `ref-${type}-${index}`, href: `#nota-${type}-${index}`, "data-type": type }, 0];
      },
      parseDOM: [
        {
          tag: "a[data-type]",
          priority: 60,
          getAttrs: (node) => {
            const href = node.getAttribute("href"),
              index = Number(href.split("-").at(-1)) || 0,
              type = node.getAttribute("data-type");
            return { href, index, type };
          }
        }
      ]
    },
    space: {
      group: "inline",
      inline: true,
      draggable: true,
      atom: true,
      attrs: {
        size: { default: 1 }
      },
      toDOM(node) {
        const { size } = node.attrs,
          sizeVar = size == null ? "" : `--pm-w:${size}ch`;

        return ["span", { /*class: "space",*/ "style": sizeVar, "data-space": size }];
      },
      parseDOM: [
        {
          tag: "span.space, span[data-space]",
          getAttrs: (node) => {
            let size = node.getAttribute("data-space");

            return { size };
          },
          priority: 60
        }
      ]
    },
    /*ghost: {
      group: "inline",
      content: "text*",
      inline: true,
      atom: true,
      toDOM(node) {
        return ["span", { "aria-hidden": "true", class: "fantasma" }, 0];
      },
      parseDOM: [
        {
          tag: "span.fantasma",
          preserveWhitespace: true,
          priority: 60
        },
        {
          tag: "span[aria-hidden='true']",
          preserveWhitespace: true,
          priority: 60
        },
      ],
      marks: ""
    },*/
    /*detailsSchema: {
      //content: "summary detailsContent",
      attrs: {
        open: { default: false },
        name: { default: null }
      },
      atom: true,
      draggable: true,
      selectable: true,
      group: "block",
      toDOM(node) {
        const { name, open } = node.attrs;

        if(!name || name.trim() === "") {
          if(!open) {
            return ["details", { open: "", class: "acordeon" }]; //, 0];
          }

          return ["details", { open: "", class: "acordeon" }] //, 0];
        }

        if(!open) {
            return ["details", { open: "", name, class: "acordeon" }] //, 0];
          }

        return ["details", { open: "", name, class: "acordeon" }] //, 0];
      },
      parseDOM: [
        {
          tag: "details",
          getAttrs: (node) => {
            const open = node.getAttribute("open"),
              name = node.getAttribute("name");

            return { open, name };
          }
        }
      ]
    },
    details: {
      content: "summary detailsContent",
      attrs: {
        open: { default: false },
        name: { default: null }
      },
      //atom: true,
      //draggable: true,
      selectable: true,
      //defining: true,
      group: "block",
      toDOM(node) {
        const { name, open } = node.attrs;

        if(!name || name.trim() === "") {
          if(!open) {
            return ["details", { class: "acordeon" }, 0]; //, 0];
          }

          return ["details", { open: "", class: "acordeon" }, 0]; //, 0];
        }

        if(!open) {
            return ["details", { name, class: "acordeon" }, 0]; //, 0];
          }

        return ["details", { open: "", name, class: "acordeon" }, 0]; //, 0];
      },
      parseDOM: [
        {
          tag: "details",
          getAttrs: (node) => {
            const open = node.getAttribute("open"),
              name = node.getAttribute("name");

            return { open, name };
          }
        }
      ]
    },
    summary: {
      content: "paragraphSummary",
      //atom: true,
      //selectable: true,
      toDOM() { return ["summary", { class: "acordeon-titulo" }, 0]; },
      parseDOM: [
        { tag: "summary" }
      ]
    },
    detailsContent: {
      content: "block+",
      toDOM() { return ["div", { class: "acordeon-contenido" }, 0]; },
      parseDOM: [
        { tag: "div.acordeon-contenido" }
      ]
    },*/
    text: { group: "inline" }
  }, marks: {
    inlineCode: {
      code: true,
      toDOM() { return ["code", 0]; },
      parseDOM: [
        { tag: "code" }
      ]
    },
    link: {
      attrs: {
        href: {},
        target: { default: null }
      },
      selectable: true,
      inclusive: false,
      toDOM(mark) {
        const target = mark.attrs.target,
          href = mark.attrs.href;

        if(href == null || href == "") {
          return false;
        }

        if(target == null) {
          return ["a", { class: "liga", href }, 0];
        }

        return ["a", { class: "liga", href, target }, 0];
      },
      parseDOM: [
        {
          tag: "a.liga:not([data-type])",
          getAttrs: (node) => {
            const href = node.getAttribute("href"),
              target = node.getAttribute("target");

            if(target == null || target === "") {
              return { href }
            }

            return { href, target }
          }
        }
      ],
      excludes: "customLink link inlineCode"
    },
    customLink: {
      attrs: {
        href: { default: null },
        type: {},
        index: { default: 0 }
      },
      selectable: true,
      inclusive: false,
      toDOM(mark) {
        const type = mark.attrs.type;
        switch(type) {
          case "autor":
          case "editor":
            return ["a", { class: "liga", href: `#nota-${type}-${mark.attrs.index}`, "data-type": type }, 0];
          default:
            return false;
        }
        
      },
      parseDOM: [
        {
          tag: "a[data-type]",
          getAttrs: (node) => {
            const href = node.getAttribute("href"),
              index = Number(href.split("-").at(-1)) || 0,
              type = node.getAttribute("data-type");
            return { href, index, type }
          }
        }
      ],
      excludes: "customLink link inlineCode"
    },
    bold: {
      toDOM() { return ["b", 0]; },
      parseDOM: [
        { tag: "strong" },
        { tag: "b", getAttrs: (node) => { node.style.fontWeight !== "normal" && null } },
        { style: "font-weight=400", clearMark: m => m.type.name === "strong" },
        { style: "font-weight", getAttrs: (value) => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null }
      ]
    },
    italics: {
      toDOM() { return ["i", 0]; },
      parseDOM: [
        { tag: "em" },
        { tag: "i" },
        { style: "font-style=italic" },
        { style: "font-style", getAttrs: (value) => /italic/.test(value) && null },
        { tag: "span.mItalicas" }
      ]
    },
    underline: {
      toDOM() { return ["u", 0]; },
      parseDOM: [
        { tag: "u" },
        { style: "text-decoration-style=underline" },
        { style: "text-decoration=underline" },
        { style: "text-decoration-style", getAttrs: (value) => value === "underline" && null },
        { style: "text-decoration", getAtrs: (value) => /underline/.test(value) && null }
      ]
    },
    strikeThrough: {
      toDOM() { return ["s", 0]; },
      parseDOM: [
        { tag: "s" },
        { tag: "del" },
        { style: "text-decoration=line-through" },
        { style: "text-decoration", getAttrs: (value) =>  /line-through/.test(value) && null },
        { style: "text-decoration-style", getAttrs: (value) => /line-through/.test(value) && null }
      ]
    },
    smallCaps: {
      toDOM() { return ["span", { class: "versalitas" }, 0]; },
      parseDOM: [
        { tag: "span", getAttrs: (node) => node.classList.contains("versalitas") },
        { style: "font-variant=small-caps" },
        { style: "font-variant", getAttrs: (value) => /(all-)?(small|petite)-caps/.test(value) && null },
        { style: "font-variant-caps", getAttrs: (value) => /(all-)?(small|petite)-caps/.test(value) && null },
        { tag: "span.mVersalitas" }
      ]
    },
    superscript: {
      toDOM() { return ["sup", 0]; },
      parseDOM: [
        { tag: "sup" },
        { style: "font-variant", getAttrs: (value) => /super/.test(value) && null },
        { style: "font-variant-position", getAttrs: (value) => /super/.test(value) && null }
      ],
      excludes: "subscript"
    },
    subscript: {
      toDOM() { return ["sub", 0]; },
      parseDOM: [
        { tag: "sub" },
        { style: "font-variant", getAttrs: (value) => /sub/.test(value) && null },
        { style: "font-variant-position", getAttrs: (value) => /sub/.test(value) && null }
      ],
      excludes: "superscript"
    },
    fontColor: {
      attrs: {
        className: { default: null }
      },
      toDOM(mark) { return ["span", { /*class: mark.attrs.className,*/ "data-color": mark.attrs.className }, 0]; },
      parseDOM: [
        {
          tag: "span[data-color]",
          gettAttrs: (node) => {
            const classesSet = new Set(validFontColorValues)
              className = node.getAttribute("data-color");

            if(classesSet.has(className)) {
              return { className };
            }

            return false;
          }
        }
      ],
      excludes: "fontColor link customLink"
    },
    backgroundColor: {
      attrs: {
        className: { default: null }
      },
      toDOM(mark) { return ["span", { /*class: mark.attrs.className,*/ "data-bg": mark.attrs.className }, 0]; },
      parseDOM: [
        {
          tag: "span[data-bg-color]",
          gettAttrs: (node) => {
            const classesSet = new Set(validBackgroundColorValues),
              className = node.getAttribute("data-bg");

            if(classesSet.has(className)) {
              return { className };
            }

            return false;
          }
        }
      ],
      excludes: "backgroundColor link customLink"
    },
    fontSize: {
      attrs: {
        className: { dafult: null }
      },
      toDOM(mark) { return ["span", { /*class: mark.attrs.className,*/ "data-size": mark.attrs.className }, 0]; },
      parseDOM: [
        {
          tag: "span[data-size]",
          getAttrs: (node) => {
            const classesSet = new Set(validFontSizeValues),
             className = node.getAttribute("data-size");

            if(classesSet.has(className)) {
              return { className };
            }

            return false;
          }
        }
      ],
      excludes: "fontSize link customLink"
    }
  }
});
